export enum SelectorGradeRangeType {
	Custom = 0,
	Shared = 1,
}
